const defaultAppPath = '/students/me';

const careerHubBaseUrl: string = (() => {
    const VITE_BASE_API_URL = import.meta.env.VITE_BASE_API_URL as string | undefined;

    const { pathname } = location;
    return VITE_BASE_API_URL || pathname.substring(0, pathname.indexOf(defaultAppPath));
})();

const apiUrl = (() => {
    return `${careerHubBaseUrl}/students/services/me`;
})();

const appPath = (() => {
    const { pathname } = location;
    const index = pathname.indexOf(defaultAppPath);
    return index === -1 ? defaultAppPath : pathname.substring(0, index) + defaultAppPath;
})();

const careerHubPath = (() => {
    const { pathname } = location;
    const index = pathname.indexOf(defaultAppPath);

    return index === -1 ? defaultAppPath : pathname.substring(0, index);
})();

export const basePathHelper = {
    apiUrl,
    appPath,
    careerHubPath,
    careerHubBaseUrl,
};
